module.exports = __webpack_public_path__ + "img/1F1FA-1F1F8.b93f6ea1.svg";